
<div style="float: right;">
    <i class="material-icons __close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>
<!-- <textarea *ngIf="isInspector" #ta [ngModel]="comment" (ngModelChange)= "commentChanged($event)"></textarea> -->
<textarea *ngIf="isInspector" [(ngModel)]="newComment"></textarea>
<span *ngIf="!isInspector">{{newComment}}</span>
<div style="display: flex;justify-content: space-between;">
    <button *ngIf="isInspector" mat-raised-button class="button" color="warn" (click)="updateComment()"
          [class.loading]="savingComment" [disabled]="savingComment">
    <span>
      {{'Save Comment' | translate | async }}
    </span>
  </button>
  <div *ngIf="isInspector && SystemId==0" style="align-content: center;">
    <mat-checkbox [(ngModel)]="AddtoInterpretationComment">
      <span class="example-margin item__bottom">{{"Add to interpretation comment" | translate | async}}</span>
    </mat-checkbox>
  </div>
  <div>
    <div *ngIf="CompartTypeCommentList!=null && CompartTypeCommentList.length>0 && SystemId==0" style="width: 300px;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;">
        <mat-form-field>
            <mat-select id="compartTypeComment" [(ngModel)]="compartTypeComment">
                <mat-option [value]="r.Name" *ngFor="let r of CompartTypeCommentList">{{r.Name}}</mat-option>
            </mat-select>
            <mat-label>{{'Auto Comment' | translate | async}}</mat-label>
        </mat-form-field>

        <button *ngIf="isInspector && SystemId==0" mat-raised-button class="button" color="warn"
              (click)="AddCompartTypeComment()">
        <span>{{'Add' | translate | async}}</span>
      </button>
    </div>
  </div>
    </div>

